import { render, staticRenderFns } from "./reserveSpace.vue?vue&type=template&id=4c94eb82"
import script from "./reserveSpace.vue?vue&type=script&lang=js"
export * from "./reserveSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports